import { render, staticRenderFns } from "./b-menu-pagination-actions-prev.vue?vue&type=template&id=3ff23c82&scoped=true&"
import script from "./b-menu-pagination-actions-prev.vue?vue&type=script&lang=js&"
export * from "./b-menu-pagination-actions-prev.vue?vue&type=script&lang=js&"
import style0 from "./b-menu-pagination-actions-prev.vue?vue&type=style&index=0&id=3ff23c82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff23c82",
  null
  
)

export default component.exports